import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { switchMap } from 'rxjs/operators';

export interface InvitationDTO {
  id: number;
  condominium: {
    id: number;
    name: string;
  };
  username: string;
  expirationTime: string;
  createTime: string;
  deleted: boolean;
  accepted: boolean;
}

export interface PageInvitationDTO {
  content: InvitationDTO[];
  totalPages: number;
  totalElements: number;
  size: number;
  number: number;
}


@Injectable({
  providedIn: 'root'
})
export class InvitationService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, private authService: AuthService) { }

  getAllInvitations(condominiumId: number, status: string, page: number, size: number): Observable<PageInvitationDTO> {
    const params = new HttpParams()
      .set('status', status)
      .set('page', page.toString())
      .set('size', size.toString());
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        const headers = { 'Authorization': `Bearer ${token}` };
        return this.http.get<PageInvitationDTO>(`${this.apiUrl}/condominium/${condominiumId}/invitation`, { params, headers });
      })
    );
  }

  createInvitation(condominiumId: number, username: string): Observable<InvitationDTO> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        const headers = { 'Authorization': `Bearer ${token}` };
        return this.http.post<InvitationDTO>(`${this.apiUrl}/condominium/${condominiumId}/invitation`, { username }, { headers });
      })
    );
  }

  getInvitationByUsername(username: string, condominiumId: number | null): Observable<InvitationDTO[]> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        const headers = { 'Authorization': `Bearer ${token}` };
        const params = new HttpParams().set('condominiumId', condominiumId?.toString());
        if (condominiumId) {
          return this.http.get<InvitationDTO[]>(`${this.apiUrl}/condominium/invitation/username/${username}`, { headers, params });
        } else {
          return this.http.get<InvitationDTO[]>(`${this.apiUrl}/condominium/invitation/username/${username}`, { headers });
        }
      })
    );
  }

  getInvitation(invitationId: number): Observable<InvitationDTO> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        const headers = { 'Authorization': `Bearer ${token}` };
        return this.http.get<InvitationDTO>(`${this.apiUrl}/condominium/invitation/invitationId/${invitationId}`, { headers });
      })
    );
  }

  updateInvitation(invitationId: number, request: any): Observable<InvitationDTO> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        const headers = { 'Authorization': `Bearer ${token}` };
        return this.http.put<InvitationDTO>(`${this.apiUrl}/condominium/invitation/${invitationId}`, request, { headers });
      })
    );
  }

  deleteInvitation(invitationId: number): Observable<void> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        const headers = { 'Authorization': `Bearer ${token}` };
        return this.http.delete<void>(`${this.apiUrl}/condominium/invitation/${invitationId}`, { headers });
      })
    );
  }

  acceptInvitation(invitationId: number): Observable<void> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        const headers = { 'Authorization': `Bearer ${token}` };
        return this.http.put<void>(`${this.apiUrl}/condominium/invitation/${invitationId}/accept`, {}, { headers });
      })
    );
  }

} 